import { createUseStyles } from "react-jss";

export default createUseStyles({
  snakeDot: {
    position: "absolute",
    width: "2%",
    height: "2%",
    backgroundColor: "#000",
    border: "1px solid #fff",
    zIndex: "2"
  }
});